<template>
  <form data-vv-scope="step-1">
    <div class="row mb-3 mt-2">
      <div class="col-12">
        <vs-input
          class="w-100"
          v-model="step.title"
          label="Título"
          data-vv-as="titulo"
          v-validate="'required'"
          name="title"
          :danger="errors.has('step-1.title')"
          :danger-text="errors.first('step-1.title')"
          :success="!errors.has('step-1.title') && step.title.length > 0"
        />
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6">
        <list-document-types
          class="w-100"
          autocomplete
          label="Tipo Documento (*)"
          name="documentType"
          v-model="step.documentType"
          :danger="errors.has('step-1.documentType')"
          :danger-text="errors.first('step-1.documentType')"
          v-validate="'required'"
          ref="documentTypes"
        />
      </div>
      <div class="col-md-6">
        <list-documents
          :type-numeration="typeNumeration"
          class="w-100"
          autocomplete
          label="Documento (*)"
          name="document"
          v-model="step.document"
          :parent-value="step.documentType"
          v-validate="{'required': isRequired}"
          :danger="errors.has('step-1.document')"
          :danger-text="errors.first('step-1.document')"
          ref="documents"
        />
      </div>
    </div>
    <div class="row mb-3" v-if="step.documentType === 'IPCAFTO'">
      <div class="col-6" >
        <vs-select
          class="w-100"
          v-model="step.proposalStatus"
          label="Estado de la propuesta"
          placeholder="Seleccione..."
        >
          <vs-select-item value="published" text="Publicado"/>
          <vs-select-item value="processed" text="Tramitado"/>
          <vs-select-item value="rejected" text="Rechazado"/>
        </vs-select>
      </div>
      <div class="col-6">
        <vs-input class="w-100" label="Cantidad de Adhesiones" v-model="step.adhesion"/>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-12">
        <vs-select
          class="w-100"
          autocomplete
          label="Formato Documento"
          name="formatDocument"
          v-model="step.formatDocument"
        >
          <vs-select-item
            :value="0"
            text="Papel"
          />
          <vs-select-item
            :value="1"
            text="Electrónico"
          />
        </vs-select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-12">
        <label>Materia</label>
        <treeselect
          v-model="step.matter"
          placeholder="Seleccione..."
          :options="ontologies"
          data-vv-as="materia"
          v-validate="'required'"
          name="matter"
        />
      </div>
      <small v-if="errors.has('step-1.matter')" class="ml-4 text-danger">
        {{errors.first('step-1.matter')}}
      </small>
    </div>
    <div class="row mb-3 mt-2">
      <div class="col-12">
        <label>Palabras clave</label>
        <Keywords v-model="step.tags"/>
      </div>
    </div>
    <div class="row mb-3 mt-2" v-if="step.documentType === 'IPCAFTO'">
      <div class="col-12">
        <label>Comisiones</label>
        <treeselect v-model="step.commissions" placeholder="Seleccione" :options="interestAreas"/>
      </div>
    </div>
    <div class="row mb-3 mt-2">
      <div class="col-6">
        <label>Acceso</label>
        <b-form-select class="w-100" v-model="step.accessRights" :options="access"/>
      </div>
      <div class="col-6">
        <!-- :invalid-feedback="errors.first('step-1.deliveryDate')" -->
        <b-form-group>
          <label>Fecha de despacho</label>
          <b-form-datepicker
            reset-button
            label-reset-button="Limpiar fecha"
            hide-header
            show-decade-nav
            start-weekday='1'
            name="deliveryDate"
            placeholder="Seleccione..."
            v-model="step.deliveryDate"
            class="form-control bg-white"
            locale="es"
          />
        </b-form-group>
      </div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';
import Treeselect from '@riophae/vue-treeselect';

import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import ListDocumentTypes from '@/febos/chile/lists/components/ListDocumentTypes';
import ListDocuments from '@/febos/chile/lists/components/ListDocuments';
import Keywords from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/Keywords';
import Ontology from '@/febos/chile/dnt/components/wizard/companies/60100003-2/utils/Ontology';
import InterestAreas from '@/febos/chile/dnt/components/wizard/companies/60100003-2/utils/InterestAreas';
import Access from '@/febos/chile/dnt/components/wizard/companies/60100003-2/utils/Access';

export default {
  mixins: [WizardStep],
  components: {
    ListDocumentTypes,
    ListDocuments,
    Keywords,
    Treeselect
  },
  data() {
    return {
      access: Access,
      interestAreas: InterestAreas,
      ontologies: Ontology,
      typeNumeration: this.$route.params.wizard,
      tag: '',
      step: {
        outputPrefix: '',
        proposalStatus: '',
        adhesion: null,
        title: '',
        deliveryDate: '',
        commissions: null,
        accessRights: 'public',
        isMotherDocument: '',
        documentType: '',
        document: '',
        formatDocument: 1,
        matter: null,
        tags: [],
        isPrivate: '1',
        ...this.draft
      }
    };
  },
  computed: {
    ...mapGetters('List', [
      'documentsState'
    ]),
    isRequired() {
      let documents = this.documentsState.list;
      if (this.typeNumeration === 'numOf') {
        documents = this.documentsState.list
          .filter((group) => group.extra.numOf);
      }
      if (this.typeNumeration === 'numInt') {
        documents = this.documentsState.list
          .filter((group) => group.extra.numInt);
      }
      return documents.length > 0;
    }
  },
  methods: {
    async isValid() {
      return this.validateForm('step-1');
    },
    getStepData() {
      const documentName = this.step.document
        ? { documentName: this.$refs.documents.getOption().label } : {};
      const documentTypeName = this.step.documentType
        ? { documentTypeName: this.$refs.documentTypes.getOption().label } : {};
      const documentOptId = this.step.document
        ? { documentOptId: this.$refs.documents.getOption().id } : {};
      const documentTypeId = this.step.documentType
        ? { documentTypeId: this.$refs.documentTypes.getOption().id } : {};

      return {
        ...this.step,
        ...documentTypeName,
        ...documentName,
        ...documentOptId,
        ...documentTypeId
      };
    },
    loadData() {
      const INPUT = '1';
      const OUTPUT = '2';
      this.step.outputPrefix = `${this.detailsFile.dnt.categoria.replace(INPUT, OUTPUT)}`;
      this.step.title = this.detailsFile.metadata
        .find((metadata) => metadata.nombre === 'title')?.valor || '';
      this.step.documentType = this.step.documentType
        || this.detailsFile.dnt.emisorCentroCostoNumero;
      this.step.matter = this.detailsFile.metadata
        .find((metadata) => metadata.nombre === 'constitute')?.valor;

      const keywords = this.detailsFile.metadata
        .find((metadata) => metadata.nombre === 'keywords')?.valor || '[]';
      this.step.tags = JSON.parse(keywords);

      this.step.commissions = this.detailsFile.dnt.solicitanteArea;
      this.step.accessRights = this.detailsFile.metadata
        .find((metadata) => metadata.nombre === 'acceso')?.valor || 'public';
      if (this.step.documentType === 'IPCAFTO') {
        this.step.proposalStatus = this.detailsFile.dnt.transporteViaTransporteVehiculoPatente;
        this.step.adhesion = this.detailsFile.dnt.plazo;
      }
    }
  },
  created() {
    if ('dnt' in this.detailsFile && this.step.title === '') this.loadData();
  }
};

</script>
<style>
.ti-input {
  border-radius: 5px;
}

</style>
